<template>
<div>
  <el-card body-style="padding: 0; width:100%">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">提现充值汇总</span>
    </div>
    <el-row>
      <el-col :span="10" style="border: 1px solid lightgray;margin: 2%;">
        <div id="CashAndDepositTotal" :style="{textAlign:'center',width: '100%', height: '56rem', margin:'2%'}">
        </div>
      </el-col>
      <el-col :span="10" style="border: 1px solid lightgray;margin: 2%;">
        <div id="CashAndDepositTotal1" :style="{textAlign:'center',width: '100%', height: '56rem', margin:'2%'}">
        </div>
      </el-col>
    </el-row>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getTotalInvestMoney} from "../../api/b2cbusiness/b2c_investmoney";
import {queryCashOutMoneyTotal} from "../../api/b2cbusiness/b2c_admin";
export default {
  name: "CashAndDepositTotal",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getTotalInvestMoney().then(res=>{
        if (res.success){
          this.drawBar(res.data, null);
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
      queryCashOutMoneyTotal().then(res=>{
        if (res.success){
          this.drawBar(null, res.data);
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    drawBar(investMoney, outMoney){
      if (investMoney != null) {
        let myChart = this.$echarts.init(document.getElementById("CashAndDepositTotal"));
        var option = {
          title: {
            text: '账户充值汇总'
          },
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['账户充值'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '金币',
              nameLocation: 'center',
              nameTextStyle: {
                padding: [0, 0, 30, 0],
                color: '#3398DB'
              }
            }
          ],
          series: [
            {
              name: '账户充值',
              type: 'bar',
              barWidth: '30%',
              data: [investMoney]
            }
          ]
        };

        myChart.setOption(option);
      }

      if (outMoney != null) {
        let myChart1 = this.$echarts.init(document.getElementById("CashAndDepositTotal1"));
        var option1 = {
          title: {
            text: '账户提现汇总'
          },
          color: ['red'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['账户提现'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '金币',
              nameLocation: 'center',
              nameTextStyle: {
                padding: [0, 0, 30, 0],
                color: 'red'
              }
            }
          ],
          series: [
            {
              name: '账户提现',
              type: 'bar',
              barWidth: '30%',
              data: [outMoney]
            }
          ]
        };

        myChart1.setOption(option1);
      }
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
